var map = {
	"./basic.png": "2db9",
	"./bg2.png": "89d4",
	"./bg3.png": "59f3",
	"./card-bg.png": "7c30",
	"./card1.png": "f061",
	"./card2.png": "2ec9",
	"./cpmplete.png": "a447",
	"./djq.png": "3035",
	"./djq_over.png": "a4c1",
	"./drop.png": "f655",
	"./get.png": "bce7",
	"./goto.png": "7cf7",
	"./hb.png": "44c1",
	"./hb_over.png": "d071",
	"./home/cun.png": "802f",
	"./home/item-img.png": "6435",
	"./home/kefu.png": "016d",
	"./home/login.png": "6204",
	"./home/notice.png": "13a1",
	"./home/qu.png": "a715",
	"./home/register.png": "c6a9",
	"./login/login-bottom.png": "84d2",
	"./login/login-bottom2.png": "8507",
	"./login/login-top.png": "f6d0",
	"./login/login-top2.png": "5ce1",
	"./login/logo.png": "ba69",
	"./login/logo1.png": "c98b",
	"./long/long1.png": "6fa2",
	"./long/long2.png": "2166",
	"./long/long3.png": "88e7",
	"./long/long4.png": "6ad2",
	"./money-r.png": "4d65",
	"./money.png": "b6a1",
	"./money_over.png": "660b",
	"./noget.png": "5f5d",
	"./over_get.png": "0e87",
	"./pingan.png": "4727",
	"./red_bg.png": "2d02",
	"./return-w.png": "38c6",
	"./return.png": "c2c5",
	"./self.png": "31a2",
	"./short/short1.png": "ed9e",
	"./short/short2.png": "0318",
	"./short/short3.png": "45fe",
	"./sign1.png": "6c1b",
	"./tab/daikuan.png": "c846",
	"./tab/daikuan2.png": "7bb8",
	"./tab/item.png": "8042",
	"./tab/kefu.png": "959d",
	"./tab/kefu1.png": "1f09",
	"./tab/kefu2.png": "c375",
	"./tab/my.png": "82a8",
	"./tab/shou.png": "3f7c",
	"./tab/shouye.png": "9ceb",
	"./tab/shouye2.png": "7702",
	"./tab/wode.png": "6de3",
	"./tab/wode2.png": "e1fa",
	"./tab/xiangmu.png": "2d81",
	"./tab/xiangmu2.png": "6510",
	"./user/item1.png": "1709",
	"./user/item11.png": "998e",
	"./user/item2.png": "a6ea",
	"./user/item4.png": "84d25",
	"./user/item5.png": "7e54",
	"./user/item6.png": "375b",
	"./user/item7.png": "6f18",
	"./user/item8.png": "8e07",
	"./user/top.png": "1f8a",
	"./user/top1.png": "a068",
	"./user/top2.png": "9422"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";